import { useAccountCreationFlow } from "../../../application/v2";
import { UnauthenticatedLayoutV2 } from "../../../ui/layout/v2";
import { SignUpPageV2 } from "../../../ui/pages/v2/SignUpPage";

export function SignUpV2Route() {
  const accountCreation = useAccountCreationFlow();

  return (
    <UnauthenticatedLayoutV2>
      <SignUpPageV2
        accountError={accountCreation.accountError}
        activeStep={accountCreation.activeStep}
        emailVerificationError={accountCreation.emailVerificationError}
        isEmailVerificationChecking={
          accountCreation.isEmailVerificationChecking
        }
        isEmailVerificationPending={accountCreation.isEmailVerificationPending}
        isVerificationEmailResending={
          accountCreation.isVerificationEmailResending
        }
        isAccountSubmitting={accountCreation.isAccountSubmitting}
        onCheckEmailVerification={accountCreation.checkEmailVerification}
        onComplete={accountCreation.complete}
        onCreateAccount={accountCreation.createAccount}
        onResendVerificationEmail={accountCreation.resendVerificationEmail}
        onSkip={accountCreation.skip}
        onStepChange={accountCreation.setActiveStep}
        provisioningView={accountCreation.provisioningView}
        verificationEmail={accountCreation.verificationEmail}
      />
    </UnauthenticatedLayoutV2>
  );
}
